<template>
  <div class="pc-university">
    <!-- 院校头部面包屑部分 -->
    <BreadCrumb :data="breadcrumb" :title="'前沿列表管理'" />
    <!-- 统计面板 -->
    <StatisticalPanel :whichModule="'exploration'" :data="overallData">
    </StatisticalPanel>
    <ModuleClassfication
      :title="titles"
      class="pc-exploration-tab"
      @addTopic="addTopic"
      @updateTopic="updateTopic"
      @deleteTopic="deleteTopic"
    />
    <!-- <div class="pc-exploration-table"> -->
    <BestPracticeTable ref="uniTable" />
    <!-- </div> -->
    <!-- 提示框 -->
    <!-- <DeleteDialog
      @isDelete="isDelete"
      @isCancel="isCancel"
      :dialogVisible="deleteShow"
      :delid="deleteId"
    /> -->
  </div>
</template>
<script>
import StatisticalPanel from "@/components/componentSet/Statistical/StatisticalPanel.vue";
import BreadCrumb from "../../componentSet/BreadCrumb";
import BestPracticeTable from "./components/ExplorationTable";
import ModuleClassfication from "@/components/componentSet/ModuleClassfication";
import {
  getExplorationCount_Api,
  getScholarDropDown_Api,
  getBpDropDown_Api,
  createExplorationContent_Api,
  deleteExplorationContent_Api,
  updateExplorationContent_Api,
  createExplorationDetail_Api,
  deleteExplorationDetail_Api,
  updateExplorationDetail_Api,
} from "@/apis/exploration.api";
export default {
  components: {
    BreadCrumb,
    BestPracticeTable,
    StatisticalPanel,
    ModuleClassfication,
  },
  data() {
    return {
      overallData: {
        title: "前沿数据",
        count: [
          { name: "前沿内容", count: null },
        ],
      },
      titles: {
        module: "前沿",
        class: [
          { name: "前沿要素", subTitles: [] },
          { name: "大类", subTitles: [] },
        ],
      },
    };
  },
  computed: {
    breadcrumb: function () {
      return [
        { name: "首页", link: "/admin/main" },
        { name: "前沿列表", link: "/admin/explorationlist" },
      ];
    },
  },
  mounted() {
    getExplorationCount_Api().then((res) => {
      console.log(res);
      this.$set(this.overallData.count[0], "count", res.data.all_count);
    });
  },

  methods: {
          updateTopic(topic, callback) {
      if (topic.type == "Titles") {
        updateScholarTitle_Api({
          chinese_name: topic.chinese_name,
          english_name: topic.english_name,
          title_id: topic.id,
          status: topic.status,
        }).then(() => {
          callback();
          this.TitleSearch();
        });
      } else if (topic.type == "Subjects") {
        updateScholarSubject_Api({
          chinese_name: topic.chinese_name,
          english_name: topic.english_name,
          subject_id: topic.id,
          status: topic.status,
        }).then(() => {
          callback();
          this.SubjectSearch();
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/exploration/ExplorationList.vue